import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'Templates',
  dir: 'Templates',
  pathRoot: '',
  routes: [
    {
      url: 'tinh-yeu-vinh-cuu',
      component: 'Page/ForeverLovePage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp cưới - Tình yêu vĩnh cửu | Smart Event',
        titleI18n: 'WeddingTemplates:title:forever_love',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'loi-the-co-dien',
      component: 'Page/ClassicVowPage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp cưới - Lời thề cổ điển | Smart Event',
        titleI18n: 'WeddingTemplates:title:classic_vow',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'hanh-trinh-bat-tan',
      component: 'Page/NeverendingJourneyPage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp cưới - Hành trình bất tận | Smart Event',
        titleI18n: 'WeddingTemplates:title:neverending_journey',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'mai-ben-nhau',
      component: 'Page/TogetherForeverPage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp cưới - Mãi bên nhau | Smart Event',
        titleI18n: 'WeddingTemplates:title:together_forever',
        headerStyle: 'fill',
        exact: true,
      },
    },

    {
      url: 'trai-tim-vang',
      component: 'Page/GoldenHeartPage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp cưới - Trái tim vàng | Smart Event',
        titleI18n: 'WeddingTemplates:title:golden_heart',
        headerStyle: 'fill',
        exact: true,
      },
    },

    {
      url: 'hoa-no-hanh-phuc',
      component: 'Page/HappyBloomingFlowersPage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp cưới - Hoa nở hạnh phúc | Smart Event',
        titleI18n: 'WeddingTemplates:title:happy_blooming_flowers',
        headerStyle: 'fill',
        exact: true,
      },
    },

    {
      url: 'vuon-hong',
      component: 'Page/RoseGardenPage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp cưới - Vườn hồng | Smart Event',
        titleI18n: 'WeddingTemplates:title:rose_garden',
        headerStyle: 'fill',
        exact: true,
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: 'Any',
};
